module.exports = __webpack_public_path__ + "static/michael-ed9f4660cc0a6f6858c2c712b9399652.jpg";